import { render, staticRenderFns } from "./SeedingSetPlant.vue?vue&type=template&id=135b6fa4&scoped=true&"
import script from "./SeedingSetPlant.vue?vue&type=script&lang=js&"
export * from "./SeedingSetPlant.vue?vue&type=script&lang=js&"
import style0 from "./SeedingSetPlant.vue?vue&type=style&index=0&id=135b6fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b6fa4",
  null
  
)

export default component.exports